var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAsesorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 27,
    fill: "none",
    viewBox: "0 0 25 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#334443",
    stroke: "#334443",
    strokeWidth: 0.2,
    d: "M24.407 12.418a2.701 2.701 0 0 0-2.36-2.671V9.74l-.09-.008-.016-.001v-.014a9.339 9.339 0 0 0-2.96-6.093 9.274 9.274 0 0 0-12.654 0h-.001a9.358 9.358 0 0 0-2.96 6.092l-.001.015-.015.001A2.706 2.706 0 0 0 .9 12.414v4.294a2.693 2.693 0 0 0 2.682 2.695h2.273a.769.769 0 0 0 .768-.768v-8.143a.769.769 0 0 0-.768-.768h-.956l.002-.018a7.772 7.772 0 0 1 7.748-7.034A7.78 7.78 0 0 1 20.4 9.706l.002.018h-.956a.769.769 0 0 0-.767.768v8.143c0 .423.344.768.767.768h.706c-.54 2.287-2.595 3.995-5.038 3.995h-.616a1.12 1.12 0 0 0-.814-.347 1.14 1.14 0 0 0 0 2.28c.322 0 .61-.135.814-.346h.616c3.317 0 6.079-2.413 6.647-5.578a2.69 2.69 0 0 0 2.645-2.695V12.42ZM3.582 11.26h1.504v6.603H3.583c-.634 0-1.15-.516-1.15-1.155v-4.294c0-.638.516-1.154 1.15-1.154Zm19.289 5.448c0 .639-.516 1.155-1.15 1.155h-1.506V11.26h1.506c.634 0 1.15.516 1.15 1.154v4.294Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsesorIcon);
export default __webpack_public_path__ + "static/media/asesorIcon.0e11dd62101327fc27bea783b7818bb1.svg";
export { ForwardRef as ReactComponent };